module.exports = __webpack_public_path__ + "static/img/p1.4603e0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/p1.jpg
// module id = 61
// module chunks = 1